var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledApplePay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_127070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.93706 15.3536C1.7484 15.341 -0.0620117 10.8732 -0.0620117 8.59789C-0.0620117 4.88112 2.72619 4.06743 3.80074 4.06743C4.285 4.06743 4.80209 4.25759 5.25816 4.42588C5.5771 4.54327 5.90694 4.66444 6.09039 4.66444C6.20019 4.66444 6.45895 4.56136 6.68741 4.47091C7.17462 4.27695 7.78089 4.03589 8.48688 4.03589C8.48814 4.03589 8.48984 4.03589 8.49107 4.03589C9.01824 4.03589 10.6166 4.15158 11.5776 5.5947L11.8027 5.93296L11.4787 6.17741C11.0159 6.52662 10.1715 7.16362 10.1715 8.42541C10.1715 9.91985 11.1278 10.4946 11.5873 10.771C11.7901 10.893 12 11.0188 12 11.294C12 11.4736 10.5661 15.3313 8.48392 15.3313C7.97442 15.3313 7.61427 15.1782 7.2966 15.0431C6.97517 14.9064 6.69789 14.7886 6.23971 14.7886C6.00747 14.7886 5.71378 14.8984 5.40287 15.015C4.97798 15.1735 4.49706 15.3536 3.95136 15.3536H3.93706Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70855 0.647705C8.76278 2.60299 7.36444 3.95948 5.96773 3.87441C5.73758 2.31402 7.36426 0.647705 8.70855 0.647705Z",
    fill: "#B5B5B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_127070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white",
    transform: "translate(0 0.599854)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledApplePay);
export default __webpack_public_path__ + "static/media/disabled-apple-pay.fb5bdce923902c22a5419a5dbb0e92d4.svg";
export { ForwardRef as ReactComponent };